import { AnaminesePreOperatoriaData } from "../interfaces/anaminesePreOperatoria.interface";

export type AnaminesePreOperatoriaFormData = AnaminesePreOperatoriaData;

export const getInitialData = (initialData?: Partial<AnaminesePreOperatoriaData>): AnaminesePreOperatoriaFormData => {
  return {
    // Comorbidades
    hipertensao: initialData?.hipertensao ?? false,
    diabetes: initialData?.diabetes ?? false,
    doencaCardiaca: initialData?.doencaCardiaca ?? false,
    doencaRespiratoria: initialData?.doencaRespiratoria ?? false,
    outrasComorbidades: initialData?.outrasComorbidades ?? "",
    medicamentosEmUso: initialData?.medicamentosEmUso ?? "",
    alergiasMedicamentos: initialData?.alergiasMedicamentos ?? "",
    cirurgiasAnteriores: initialData?.cirurgiasAnteriores ?? "",
    // Histórico Oftalmológico
    dadosInicioPerdaVisual: initialData?.dadosInicioPerdaVisual ?? "",
    usoOculosLentes: initialData?.usoOculosLentes ?? false,
    tempoUsoOculosLentes: initialData?.tempoUsoOculosLentes ?? "",
    diagnosticoDoencasOculares: initialData?.diagnosticoDoencasOculares ?? "",
    // Hábitos
    fuma: initialData?.fuma ?? false,
    quantidadeCigarros: initialData?.quantidadeCigarros ?? "",
    frequenciaCigarros: initialData?.frequenciaCigarros ?? "",
    consumoAlcool: initialData?.consumoAlcool ?? false,
    frequenciaAlcool: initialData?.frequenciaAlcool ?? "",
    // Avaliação Pré-Operatória
    ocorrenciaAdversaAnestesia: initialData?.ocorrenciaAdversaAnestesia ?? false,
    dificuldadeMovimentacao: initialData?.dificuldadeMovimentacao ?? false,
    // Sinais Vitais
    pressaoArterial: initialData?.pressaoArterial ?? "",
    frequenciaCardiaca: initialData?.frequenciaCardiaca ?? "",
    temperatura: initialData?.temperatura ?? "",
    peso: initialData?.peso ?? "",
    altura: initialData?.altura ?? "",
    // Exames
    acuidadeVisualOD: initialData?.acuidadeVisualOD ?? "",
    acuidadeVisualOE: initialData?.acuidadeVisualOE ?? "",
    biometria: initialData?.biometria ?? "",
    outrosExames: initialData?.outrosExames ?? "",
    examesOftalmologicos: initialData?.examesOftalmologicos ?? [],
  };
};
